var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDocIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 23,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.429.2h12.137L20 6.37v14.456c0 .76-.64 1.375-1.429 1.375H1.43C.64 22.2 0 21.586 0 20.826V1.576C0 .816.64.2 1.429.2Z",
  fill: "#3C9AF2"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.98 6.389H15c-.788 0-1.428-.616-1.428-1.375V.215L19.98 6.39Z",
  fill: "#0E73D2"
})));
export default SvgDocIcon;